/* eslint-disabled */

export default class NoteExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
